module.exports = __webpack_public_path__ + "img/Partners2.fdad22e6.png";